export { default } from './HeartPixel'
